import { combineReducers } from 'redux';

import filters from './filters';
import listingsSortOrder from './listingsSortOrder';
import searchResults from './searchResults';
import taxonomy from './taxonomy';
import optimizely from './optimizely';
import user from './user';

const rootReducer = combineReducers({
    filters,
    listingsSortOrder,
    searchResults,
    taxonomy,
    optimizely,
    user
});

export default rootReducer;
